import { IconActionChevronLeft12, IconActionChevronRight12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { Settings } from 'react-slick';

const SLIDES_TO_SHOW = 5;

export const useCarouselSettings = (itemsCount: number): Settings => {
  const infinite = itemsCount > SLIDES_TO_SHOW;

  return React.useMemo(
    () => ({
      dots: false,
      infinite,
      autoplay: false,
      slidesToShow: SLIDES_TO_SHOW,
      slidesToScroll: SLIDES_TO_SHOW,
      adaptiveHeight: true,
      nextArrow: (
        <button title="Вперед">
          <IconActionChevronRight12 />
        </button>
      ),
      prevArrow: (
        <button title="Назад">
          <IconActionChevronLeft12 />
        </button>
      ),
    }),
    [infinite],
  );
};
